import { handleActions } from 'redux-actions';
import * as apiActions from '../actions'; 


const defaultState = {
    error: '',
    loginStatus:false,
    optingBtnStatus:false,
    salesForceData: [],
    salesForceProcess:{},
    salesForceEmail:{},
    salesForceEmailOptingOut:{},
    customerInformation:{}
  };

  export const salesForce = handleActions(
    {
      [apiActions.salesForceSuccess]: (state, action) => {
          return {
            ...state,
            salesForceData: action.payload
          };
        },
      [apiActions.salesForceLoginStatus]: (state, action) => {
          return {
            ...state,
            loginStatus: action.payload
          };
        },
      [apiActions.salesForceOpingOutStatus]: (state, action) => {
          return {
            ...state,
            optingBtnStatus: action.payload
          };
        },
      [apiActions.salesForceEmailSuccess]: (state, action) => {
          return {
            ...state,
            salesForceEmail: action.payload
          };
        },
      [apiActions.salesForceEmailOptingOutSuccess]: (state, action) => {
          return {
            ...state,
            salesForceEmailOptingOut: action.payload
          };
        },
      [apiActions.salesForceCustomerInfomationSuccess]: (state, action) => {
          return {
            ...state,
            customerInformation: action.payload
          };
        },
        [apiActions.salesForcePropcessSuccess]: (state, action) => {
          return {
            ...state,
            salesForceProcess: action.payload
          };
        },
        [apiActions.salesForceFail]: (state, action) => {
          return {
            ...state,
            error: action.payload
          };
        },
      },
      
    defaultState
  );

